import CustomerSsoDomainDto from './CustomerSsoDomainDto';

class CustomerSsoConfigurationDto {

    IsEnabled: boolean;
    AutoProvisionUsers: boolean;
    AutoProvisionRole: number;
    LoginSlug: string;
    IdpEntityId: string;
    IdpSignOnUrl: string;
    IdpMetadataUrl: string;
    IdpSigningCertificate: string;
    ProvisioningStatus: string;
    ProvisioningError: string;
    ServiceProviderMetadataUrl: string;
    Domains: CustomerSsoDomainDto[];

    constructor(isEnabled: boolean, autoProvisionUsers: boolean, autoProvisionRole: number, loginSlug: string, idpEntityId: string, idpSignOnUrl: string, idpMetadataUrl: string, idpSigningCertificate: string, provisioningStatus: string, provisioningError: string, serviceProviderMetadataUrl: string, domains: CustomerSsoDomainDto[]) {
        this.IsEnabled = isEnabled;
        this.AutoProvisionUsers = autoProvisionUsers;
        this.AutoProvisionRole = autoProvisionRole;
        this.LoginSlug = loginSlug;
        this.IdpEntityId = idpEntityId;
        this.IdpSignOnUrl = idpSignOnUrl;
        this.IdpMetadataUrl = idpMetadataUrl;
        this.IdpSigningCertificate = idpSigningCertificate;
        this.ProvisioningStatus = provisioningStatus;
        this.ProvisioningError = provisioningError;
        this.ServiceProviderMetadataUrl = serviceProviderMetadataUrl;
        this.Domains = domains;
    }
}

export default CustomerSsoConfigurationDto;
